<template>
  <div class="custom-tree-bd">
    <el-tree
      ref="tree"
      :data="data"
      highlight-current
      :default-expanded-keys="expandedKeys"
      :node-key="nodeKey"
      v-bind="$attrs"
      v-on="$listeners"
      @node-click="handleNode"
      :filter-node-method="filterNode"
    >
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="line1" :class="{ disable: data.state == 0 }">
          <slot name="label" v-bind="{ node, data }">{{ node.label }}</slot>
        </div>
        <div v-if="action && val && val[nodeKey] === data[nodeKey]">
          <el-button v-if="action.add" type="text" size="mini" @click.stop="handleAction('add', data, node)">
            <div class="icon-btn"><i class="icon icon-tianjia"></i></div>
          </el-button>
          <el-button v-if="action.edit" type="text" size="mini" @click.stop="handleAction('edit', data, node)">
            <div class="icon-btn"><i class="icon icon-bianji"></i></div>
          </el-button>
          <el-button v-if="action.delete" type="text" size="mini" @click.stop="handleAction('delete', data, node)">
            <div class="icon-btn"><i class="icon icon-shanchu"></i></div>
          </el-button>
          <el-button v-if="action.state" type="text" size="mini" @click.stop="handleAction('state', data, node)">
            <div class="icon-btn">
              <i v-if="data.state" class="icon icon-jinyong1"></i>
              <i v-else class="icon icon-qiyong"></i>
            </div>
          </el-button>
        </div>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    data: Array, // 列表数据
    value: Object, // 绑定值
    nodeKey: String, // key字段
    action: Object, // 操作
    filterKeys: Array, // 过滤字段
    listener: String, // 监听过滤
    default: Boolean, // 默认选择第一项
  },
  data() {
    return {
      val: this.value || {},
      expandedKeys: [],
    };
  },
  watch: {
    value() {
      this.val = this.value;
      const has = this.data.find(t => t[this.nodeKey] === this.val[this.nodeKey]);
      this.$refs.tree.setCurrentKey(has && this.val[this.nodeKey]);
    },
    data() {
      this.init();
      this.handleFilter(this.listener);
    },
    listener(newVal) {
      this.handleFilter(newVal);
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      if (this.val && !this.val[this.nodeKey] && this.default && this.data && this.data.length) {
        this.val = this.data[0];
        this.$emit('input', this.val);
        this.$emit('handleNode', this.val);
      }
      if (this.val && this.val[this.nodeKey]) {
        this.expandedKeys = [this.val[this.nodeKey]];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.val[this.nodeKey]);
        });
      }
    },
    // 点击行
    handleNode: function (data) {
      this.val = data;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.val[this.nodeKey]);
      });
      this.$emit('input', data);
      this.$emit('handleNode', data);
    },
    // 操作
    handleAction: function (name, data) {
      this.$emit(name, data);
    },
    // 过滤事件
    filterNode: function (keyWord, data) {
      if (!keyWord) {
        return true;
      }
      const valueList = this.filterKeys.map(t => data[t]);
      return valueList.some(t => t.includes(keyWord));
    },
    // 搜索过滤事件
    handleFilter: function (keyWord) {
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.filter(keyWord);
        }
      });
    },
    getCheckedNodes: function () {
      if (this.$refs.tree) {
        return this.$refs.tree.getCheckedNodes();
      }
      return undefined;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.custom-tree-bd {
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    font-size: 12.5px;
    padding-right: 8px;
    .line1.disable {
      color: $--color-info;
    }
  }
  // 展开箭头颜色
  .el-tree-node__expand-icon {
    color: $--color-text-primary;
    margin-left: 8px;
    &.is-leaf {
      color: transparent;
    }
  }

  // 选中行样式
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background: #f8f9fa;
    border: 1px solid $--color-primary;
    border-radius: 8px;
    .custom-tree-node {
      font-size: 14px;
      font-weight: bold;
      color: $--color-primary;
    }
  }

  // 默认样式
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    .custom-tree-node {
      font-size: 14px;
      color: $--color-text-regular;
    }
  }

  .icon-btn {
    cursor: pointer;
    width: 21px;
    height: 21px;
    line-height: 20px;
    color: $--color-text-primary;
    border: 1px solid $--color-text-primary;
    box-sizing: border-box;
    border-radius: 21px;
  }
}
</style>
